document.addEventListener('DOMContentLoaded', () => {
  const alphaBtns = document.querySelectorAll('.alpha-btn');
  const tabBtns = document.querySelectorAll('.tab');
  const items = document.querySelectorAll('.menu-item');

  let activeTab = 'all';
  let activeLetter = null;

  function filterItems() {
    items.forEach(item => {
      const letterMatch = !activeLetter || item.dataset.letter === activeLetter;
      const tabMatch = activeTab === 'all' || item.dataset.platform.includes(activeTab);
      item.style.display = (letterMatch && tabMatch) ? '' : 'none';
    });
  }

  alphaBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      alphaBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      activeLetter = btn.dataset.letter;
      filterItems();
    });
  });

  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      tabBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      activeTab = btn.dataset.tab;
      filterItems();
    });
  });
});
